import { useCallback } from "react";
import { noop } from "lodash";
import { setLocation } from "utils/helpers";
import {
	trackContactLinkClick,
	trackOutboundLinkClick
} from "./utils/clickTrackingUtils";

const useClickTracking = ({ onClick = noop, href, target }) => {
	const handleClick = useCallback(
		(evt) => {
			if (href && target !== "_blank") {
				evt.preventDefault();
				setLocation(href);
				const isTelTag = href.includes("tel:");
				const isMailTag = href.includes("mailto:");

				if (isTelTag || isMailTag) {
					const { id, className, innerText } = evt.target;

					const tagType = isTelTag ? "tel" : "mailto";

					trackContactLinkClick(
						id || className,
						innerText,
						innerText,
						tagType
					);
				}
			} else if (href && target.includes("blank")) {
				const { id, innerText } = evt.target;

				trackOutboundLinkClick(
					id || "outbound-link",
					innerText,
					innerText,
					href
				);
			}

			Promise.resolve(onClick(evt));
		},
		[onClick, href, target]
	);

	return { handleClick };
};

export default useClickTracking;
